import { BatterWarning } from "@npd-ng/adp-benchmark";
import { Content } from "../types/Content";
import { Dispatch } from "react";
import { IADPHeaderActions } from "../state/Actions";
import { actions } from "../state";
export default function LowBatterWarning(props:{showBatteryWarning:boolean,content: Content,
    dispatch:Dispatch<IADPHeaderActions>}) {
       const onClose = () => {
        props.dispatch(actions.createSetBatteryWarningAction(false as any));
    }
    return (
        <>
            {
                props.showBatteryWarning &&
                <BatterWarning
                    title={props.content?.deviceReadiness.BatteryWarning?.title}
                    subTitle={props.content?.deviceReadiness.BatteryWarning?.subTitle}
                    closeAction={onClose}
                />
            }
        </>
    )
}